import { calcPermissions } from '../../shared/accountPermissions';

export const SET_UI_PERMS = 'SET_UI_PERMS';
export function setUIPerms(selectedAccount, allUserRoles) {
  return {
    type: SET_UI_PERMS,
    payload: calcPermissions(selectedAccount, allUserRoles),
  };
}
